import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login'),
        meta: {
            guest: true
        }
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('@/views/ForgotPassword'),
        meta: {
            guest: true
        }
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password',
        component: () => import('@/views/ResetPassword'),
        meta: {
            guest: true
        }
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home'),
        meta: {
            user: true,
            layout: 'logged'
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/Home'),
        meta: {
            user: true,
            layout: 'logged'
        }
    },
    {
        path: '/employees',
        name: 'employees',
        component: () => import('@/views/Employees'),
        meta: {
            admin: true,
            layout: 'logged'
        }
    },
    {
        path: '/contracts',
        name: 'contracts',
        component: () => import('@/views/Contracts'),
        meta: {
            user: true,
            layout: 'logged'
        }
    },
    {
        path: '/requests',
        name: 'requests',
        component: () => import('@/views/VacationRequests'),
        meta: {
            user: true,
            layout: 'logged'
        }
    },
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/Settings'),
        meta: {
            user: true,
            layout: 'logged'
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/views/Profile'),
        meta: {
            user: true,
            layout: 'logged'
        }
    },
    {
        path: '/holidays',
        name: 'holidays',
        component: () => import('@/views/Holidays'),
        meta: {
            user: true,
            layout: 'logged'
        }
    },
    { path: '*', redirect: '/home' }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const user = JSON.parse(localStorage.getItem('loggedUser'));

    if (to.matched.some(records => records.meta.guest)) {
        if (user) {
            return next({ name: 'home' });
        }

        return next();
    }

    if (!user) {
        return next({ name: 'login' });
    }

    const isAdmin =
        user.roles && user.roles.some(role => role.name === 'admin');
    const isUser = user.roles && user.roles.some(role => role.name === 'user');

    if (to.matched.some(records => records.meta.admin)) {
        if (!isAdmin) {
            return next({ name: 'login' });
        }
    } else if (to.matched.some(records => records.meta.user)) {
        if (!(isAdmin || isUser)) {
            return next({ name: 'login' });
        }
    }

    return next();
});

export default router;
